/** Beschriftungen der Rechnungs-Felder — 1:1 aus den `[Caption(...)]`-Attributen der DLL. */

import type { CaptionMap } from '../captions';
import type { Receipt } from '../entities';

const captions = {
  AnzahlCont: 'Container Count',
  ArtAufteilung: 'Division Type',
  Belegdatum: 'Receipt Date',
  Buchdatum: 'Booking Date',
  DL: 'DL',
  GesamtbetragNetto: 'Net Total',
  GesamtbetragNettoEuro: 'Net Total EUR',
  Kurs: 'Rate',
  Rechnungsart: 'Receipt Type',
  Rechnungsnummer: 'Receipt Number',
  Rechnungszuordnung_Container_Bestellposition_BuchungsperiodeWare:
    'Assignment Container Position Sage Booking Period',
  Rechnungszuordnung_Container_Bestellposition_SageBuchungDatum:
    'Assignment Container Position Sage Booking Date',
  Wkz: 'Goods Label',
  Zuordnungen: 'Assignments',
} satisfies Partial<Record<keyof Receipt, string>>;

export const receiptCaptions: CaptionMap = captions;
